module.exports = __webpack_public_path__ + "img/Advanced-Good-Corporate-Governance.b13710af.jpg";